import React, { FunctionComponent, ReactElement, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CaptionFont from '../../../Theme/Fonts/Caption'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type VideoControlsBottomPortraitProps = {
    /** current video time formatted as string */
    currentVideoTime: string
    /** duration formatted as string */
    formattedDuration: string
    /** boolean to determine if fullScreen is enabled or not */
    fullScreenModeActive: boolean
    /** callback when screen mode changes
     *
     * @TJS-type function
     */
    onScreenModeChange: () => void
} & TestID

const VideoControlsBottomPortrait: FunctionComponent<VideoControlsBottomPortraitProps> = ({
    currentVideoTime,
    formattedDuration,
    fullScreenModeActive,
    onScreenModeChange,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand testID={testID}>
            <Grid paddingLeft={5} horizontal alignBottom noExpand>
                <CaptionFont color="WHITE" bold>
                    {currentVideoTime}
                </CaptionFont>
                <Grid horizontal alignRight alignBottom>
                    <CaptionFont color="WHITE" bold>
                        {formattedDuration}
                    </CaptionFont>
                    <Touchable onPress={onScreenModeChange}>
                        <Grid noExpand height={44} width={44} alignBottom>
                            <Grid noExpand marginLeft={5} paddingBottom={1}>
                                <FontelloIcon
                                    name={fullScreenModeActive ? 'fullscreen-exit' : 'fullscreen'}
                                    color="WHITE"
                                />
                            </Grid>
                        </Grid>
                    </Touchable>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default memo(VideoControlsBottomPortrait)
